export default __webpack_public_path__ + "static/media/RepairModule.292e6dcd.png";